$(document).ready(function () {

    // __________ Header Drawer
    $('.menu-drawer__menu li.has_dropdown-menu > .menu-drawer__menu-item').click(function(e){
        e.preventDefault();
        $(this).toggleClass('active');
        $(this).next('.menu-drawer__dropdown').slideToggle();
    });
    $('.menu-drawer__menu li.has_subdropdown-menu > .menu-drawer__menu-item').click(function(e){
        e.preventDefault();
        $(this).toggleClass('active');
        $(this).next('.menu-drawer__subdrop').slideToggle();
    });
    // __________ Header Drawer
    
    function window_inner_height(){
        $('html').css('--window-height',($(window).height())+'px');
    }
    window_inner_height();
    $(window).on('resize',function(){
        window_inner_height();
    });

    // ------------  Announcement Bar
    if($('#announcement__bar').length > 0){
        $('html').css('--announcement-bar',($('#announcement__bar').innerHeight())+'px');
        var header_announcement_speed = $('#announcement__bar').data('desktop-speed');
        if ($(window).width() < 750) {
            header_announcement_speed = $('#announcement__bar').data('mobile-speed');
        }
        $('#announcement__bar .marquee').marquee({
            gap: 0,
            speed: header_announcement_speed*1000,
            delayBeforeStart: 1000,
            direction: 'left',
            duplicated: true
        });
    }
    // ------------  Announcement Bar

    // ------------  featured collection
    if($('.featured-collection').length > 0){
        var featured_collection = new Swiper(".featured-collection .featured-collection-slider", {
            slidesPerView: 'auto',
            spaceBetween: 12,
            mousewheel: {
                forceToAxis: true
            },
            loop: true,
            pagination: {
                el: ".featured-collection .swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                1201: {
                    spaceBetween: 20,
                }
            }
        });
    }
    // ------------  featured collection


    // ------------  Featured Blog
    if($(window).width() < 750){
        var shop_by_category = new Swiper(".featured-blog .featured-blog-slider", {
            slidesPerView: 1,
            spaceBetween: 12,
            loop: true,
            mousewheel: {
                forceToAxis: true
            },
            pagination: {
                el: ".featured-blog .swiper-pagination",
                clickable: true,
            },
        });
    }
    // ------------  Featured Blog



    // ------------  Reasearch About Block
    if($('.research-about-blocks').length > 0){
        $('.research-about-blocks-button').click(function(e){
            e.preventDefault();
            $(this).parents('.research-about-blocks').toggleClass('show-all-block');
        });
    }
    // ------------  Reasearch About Block


    // ------------  product Media
    if($('.main-product').length > 0){
        $('.main-product .product__main-media-list:not(.swiper-initialized) .swiper-slide:nth-child(5)').click(function(e){
            if($(window).width() > 750){
                e.preventDefault();
                $('#product__main-media-list').addClass('show-all');
            }
        });

        window.product_main_thumb = new Swiper('.main-product #product__main-media-thumb',{
            slidesPerView: 3.6,
            spaceBetween: 8.5,
            watchSlidesProgress: true,
            centeredSlides: false,
            slideToClickedSlide: true,
            mousewheel: {
                forceToAxis: true
            },
            breakpoints: {
                990: {
                    spaceBetween: 16,
                    slidesPerView: 5.5,
                },
                750: {
                    spaceBetween: 16,
                    slidesPerView: 4.5,
                }
            }
        });

        if($(window).width() < 750){
            window.product_main_media = new Swiper('.main-product #product__main-media-list',{
                slidesPerView: 1,
                spaceBetween: 12,
                initialSlide: $('.product__main-media-list [data-featured-media]').length > 0 ? $('.product__main-media-list [data-featured-media]').index() : 0,
                mousewheel: {
                    forceToAxis: true
                },
                thumbs: {
                    swiper: product_main_thumb
                }
            });
        }
    }
    // ------------  product Media

    // ------------  Product Testimonial
    if($('.main-product .product-testimonials').length > 0){
        var product_reviews = new Swiper(".main-product .product-testimonials", {
            slidesPerView: 1.13,
            spaceBetween: 12,
            loop: true,
            mousewheel: {
                forceToAxis: true
            },
            navigation: {
                nextEl: '.product-testimonials-wrap .swiper-button-next',
                prevEl: '.product-testimonials-wrap .swiper-button-prev',
            },
            breakpoints: {
                990: {
                    spaceBetween: 14,
                    slidesPerView: 2,
                },
                750: {
                    spaceBetween: 14,
                    slidesPerView: 1.3,
                }
            }
        });
    }
    // ------------  Product Testimonial


    // ------------  Comparison Table
    if($('.comparison-table').length > 0){
        var comparision_table = new Swiper(".comparison-table .comparison-table-column-slider", {
            slidesPerView: 'auto',
            spaceBetween: 0,
            mousewheel: {
                forceToAxis: true
            },
            pagination: {
                el: ".comparison-table .swiper-pagination",
                type: 'progressbar'
            },
        });
    }
    // ------------  Comparison Table

    // ------------  Related Product
    if($('.related-products').length > 0){
        setTimeout(() => {
            var related_product = new Swiper(".related-products .related-products-slider", {
                slidesPerView: 'auto',
                spaceBetween: 15,
                loop: true,
                pagination: {
                    el: ".related-products .swiper-pagination",
                    clickable: true,
                },
                breakpoints: {
                    1201: {
                        spaceBetween: 20,
                    }
                }
            });
        }, 5000);
    }
    // ------------  Related Product


    // ------------  Related Product
    if($('.featured-collection-two').length > 0){
        var featured_collection_two = new Swiper(".featured-collection-two .featured-collection-two-slider", {
            slidesPerView: 'auto',
            spaceBetween: 15,
            loop: true,
            pagination: {
                el: ".featured-collection-two .swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                1201: {
                    spaceBetween: 20,
                }
            }
        });
    }
    // ------------  Related Product

    // ------------  Faqs
    if($('[data-faq-block]').length > 0){
        $('[data-faq-toggle]').click(function(){
            if ($(this).parents('[data-faqs-main="one-at-time"]').length > 0) {
                $(this).parents('[data-faq-block]').siblings('[data-faq-block].active').removeClass('active').find('[data-faq-content]').slideUp();
            }
            $(this).next('[data-faq-content]').slideToggle();
            $(this).parents('[data-faq-block]').toggleClass('active');
        });
    }
    // ------------  Faqs

    
});